import React from "react";
import HomeServices from "../components/home/HomeServices";
import Layout from "../common/Layout";
import AboutUs from "../components/about-us/AboutUs";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
// import ProjectsTypeOne from "../components/projects/projects-one/ProjectsTypeOne";
import Testimonial from "../components/testimonial/Testimonial";
// import TeamMembers from "../components/team-members/TeamMembers";
import Faq from "../components/faq/Faq";
// import HomePost from "../components/home/HomePost";
import HeroSlider from "../components/hero-slider/HeroSlider";
import {Helmet} from "react-helmet";

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Iron Wall X || Professional Security Services in Turkey</title>
                <meta name="description" content="Iron Wall X - Turkey's leading security company offering 24/7 protection services, CCTV surveillance, corporate & residential security, armed guards, and security consulting. Trusted by businesses across Turkey." />
                <meta name="keywords" content="security company Turkey, professional security services, CCTV Turkey, corporate security Turkey, residential security, armed security guards, security consulting Turkey, Iron Wall X, Turkish security firm, Istanbul security, Ankara security" />
            </Helmet>
            <Layout>
                <HeroSlider/>
                <AboutUs/>
                <WhyChooseUs/>
                <HomeServices/>
                {/* <ProjectsTypeOne/> */}
                <Testimonial/>
                {/* <TeamMembers/> */}
                <Faq/>
                {/* <HomePost/> */}
            </Layout>
        </>
    );
}

export default Home;